import { useCallback } from 'react';
import { ViewMode } from '../models/preferences';

interface UseHandleDisplayDateArgs {
  viewMode: ViewMode;
  handleChangeViewMode: (arg: ViewMode) => void;
}

export function useHandleDisplayDate({
  viewMode,
  handleChangeViewMode,
}: UseHandleDisplayDateArgs): { handleDisplayDate: () => void } {
  const handleDisplayDate = useCallback(() => {
    switch (viewMode) {
      case ViewMode.DAY:
        return handleChangeViewMode(ViewMode.WORK_WEEK);
      case ViewMode.WORK_WEEK:
      case ViewMode.WEEK:
        return handleChangeViewMode(ViewMode.MONTH);
    }
  }, [handleChangeViewMode, viewMode]);

  return { handleDisplayDate };
}
